import { merge } from 'lodash';

import { defaultConfig } from './default.config';
import { defaultProdConfig } from './prod.config';
import { joinPath } from '../utils/url';

const isLocalhost = window.location.hostname === 'localhost';
const isLocalDev = window.location.hostname.endsWith('.local.dev.class.com');

export const BASE_URL = `${window.location.protocol}//${window.location.host}`;

let config = merge({}, defaultConfig, defaultProdConfig);

let isConfigFetched = false;
export const getConfig = () => {
    if (!isConfigFetched) {
        throw new Error('Config not fetched yet.');
    }

    return config;
};

const fetchConfig = async (fileName: string) => {
    try {
        const configData = await fetch(joinPath(BASE_URL, fileName));
        const configJson = await configData.json();
        const { pod_region, pod_name, ...restOfConfig } = configJson;

        config = merge({}, config, {
            ...restOfConfig,
            ...(pod_region !== undefined && { podRegion: pod_region }),
            ...(pod_name !== undefined && { podName: pod_name })
        });
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
        if (isLocalhost || isLocalDev) {
            console.info(`Attempt to load config '${fileName}' failed. (This is fine on localhost)`);
            return;
        }

        console.error(`Failed to load config '${fileName}'`);
    }
};

export const loadAppConfig = async () => {
    if (isLocalhost || isLocalDev) {
        try {
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            const { localConfig } = require('./local.config');
            config = merge({}, config, localConfig);
        } catch {
            console.info('No local.config.ts found — continuing without it.');
        }
    }
    await fetchConfig('env.json');
    isConfigFetched = true;
};
